export const MAX_SLIPPAGE_DEFAULT_EVM = 1
export const MAX_SLIPPAGE_DEFAULT_SOLANA = 1
export const MAX_SLIPPAGE_LOCAL_STORAGE_KEY =
  "opensea-wallet-swap-max-slippage-v2"
export const USD_INPUT_MODE_PREFERENCE_LOCAL_STORAGE_KEY =
  "opensea-wallet-swap-usd-input-preference"

export const getDefaultSlippage = (chainArch: string | undefined) => {
  if (chainArch === "SVM") {
    return MAX_SLIPPAGE_DEFAULT_SOLANA
  }
  return MAX_SLIPPAGE_DEFAULT_EVM
}

export const getMaxSlippageStorageKey = (chainArch: string | undefined) => {
  const suffix = chainArch === "SVM" ? "solana" : "evm"
  return `opensea-wallet-swap-max-slippage-v2-${suffix}`
}
